/**
 * Источник видео-референса под плеером (спека §12): ссылка, площадка, автор, подпись (свёрнута до 3 строк),
 * просмотры / лайки / комментарии (только что есть), публикация, размер и длительность, разбор.
 */
import { useState } from "react";
import { Link } from "react-router";

import { num, when } from "@/lib/media";
import { fmtTime, platformLabel, type VideoRefInfo } from "@/lib/videoRef";

export function RefSource({ info }: { info: VideoRefInfo }) {
  const [open, setOpen] = useState(false);
  const stats = [
    info.views != null ? `просмотры ${num(info.views)}` : null,
    info.likes != null ? `лайки ${num(info.likes)}` : null,
    info.comments != null ? `комментарии ${num(info.comments)}` : null,
  ].filter(Boolean);
  const size = [
    info.width && info.height ? `${info.width}×${info.height}` : null,
    info.duration_ms ? fmtTime(info.duration_ms) : null,
    info.fps ? `${Math.round(info.fps)} к/с` : null,
  ].filter(Boolean);
  const split = info.split;

  return (
    <div className="grid gap-1 text-[12px] text-fg-muted" data-annot="видео-референс: источник">
      <div className="flex flex-wrap items-baseline gap-x-2">
        <span className="font-medium text-fg">{platformLabel(info.platform)}</span>
        {info.url ? (
          <a href={info.url} target="_blank" rel="noreferrer" className="text-accent-text hover:underline">
            ссылка ↗
          </a>
        ) : null}
        {info.pin_id ? (
          <Link to={`/pins/${info.pin_id}`} className="text-accent-text hover:underline">
            пин {info.pin_id} ↗
          </Link>
        ) : null}
        {info.uploader ? (
          info.uploader_url ? (
            <a href={info.uploader_url} target="_blank" rel="noreferrer" className="hover:text-fg">
              {info.uploader}
            </a>
          ) : (
            <span>{info.uploader}</span>
          )
        ) : null}
      </div>
      {info.caption ? (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          title={open ? "свернуть" : "развернуть"}
          className={`text-left whitespace-pre-line ${open ? "" : "line-clamp-3"}`}
        >
          {info.caption}
        </button>
      ) : null}
      {stats.length ? <div>{stats.join(" · ")}</div> : null}
      {info.date_publish ? <div>опубликован {when(info.date_publish)}</div> : null}
      {size.length ? <div className="tnum">{size.join(" · ")}</div> : null}
      {split ? (
        <div className="text-fg-faint">
          разбор: порог {split.threshold} · склеек {split.cuts.length}
          {split.merged ? ` · склеено похожих ${split.merged}` : ""}
          {split.even_split ? ` · равномерно ${split.even_split}` : ""}
          {split.sidecar ? "" : " · без сравнения кадров"}
        </div>
      ) : null}
      <div className="text-fg-faint">
        добавил {info.author_name ?? "—"} {when(info.date_create)}
        {info.date_ready ? ` · разобран ${when(info.date_ready)}` : ""}
      </div>
    </div>
  );
}
